module.exports = __webpack_public_path__ + "img/module-title_blue.035640f7.jpg";